export let notification = {
  inValidPasswordErrorMessage: "Password Does Not Match",
  invalidPasswordQuality:
    "Password does not meet the minimum system quality password requirement",
      remarkInvestigator: "I’m the Investigator Validator",
};
